import { useState } from "react";
import { IDataResult, ResponseStatus } from "../../common/models/Result";
import { DataUtils } from "../../common/views/DataUtils";
import { Utils } from "../../common/views/Utils";
import { OrderModel } from "../../orders/models/OrderModel";
import { ShortPaymentModel } from "../models/PaymentModels";
import { PaymentService } from "../services/PaymentService";

export function usePaymentVM() {
    const paymentService = new PaymentService();

    const [payment, setPayment] = useState<ShortPaymentModel | null>(null);
    const [payments, setPayments] = useState<ShortPaymentModel[]>([]);
    const [listHash, setListHash] = useState<number>(0);
    const [selectedOrder, setSelectedOrder] = useState<OrderModel | null>(null);

    const [loading, setLoading] = useState(false);
    const [showDetail, setShowDetail] = useState(false);
    const [showOrderDetail, setShowOrderDetail] = useState(false);

    const getList = () => {
        setLoading(true);
        setPayments([]);
        setListHash(Utils.getRandomKey());

        const request = paymentService.getList();

        DataUtils.onRequest(request, onSearchResult);
    }

    const onSearchResult = (result: IDataResult) => {
        if (result.status === ResponseStatus.success && result.data) {
            const payments = result.data as ShortPaymentModel[];
            setPayments(payments);
            setListHash(Utils.getRandomKey());
        }

        setLoading(false);
    }

    return {
        payment, setPayment,
        payments,
        listHash,
        selectedOrder, setSelectedOrder,

        loading, setLoading,
        showDetail, setShowDetail,
        showOrderDetail, setShowOrderDetail,

        getList,
        //get
    }
}